module.exports = __webpack_public_path__ + "static/dwarvish-sample-PHB-d03ca62ccdda5ab775dba4361ecd6844.jpg";